import type { CreateCompanyRequest, UpdateCompanyRequest } from '$lib/api/types';

export type CompanyFormValues = {
	name: string;
	businessNumber: string;
	address: string;
	phone: string;
	workStartTime: string;
	workEndTime: string;
};

type CompanyRequest = CreateCompanyRequest | UpdateCompanyRequest;

export type CompanyFormResult =
	| { ok: true; request: CompanyRequest }
	| { ok: false; message: string };

function optionalText(value: string) {
	const trimmed = value.trim();
	return trimmed || undefined;
}

function toApiTime(value: string) {
	return value ? `${value}:00` : undefined;
}

export function validateCompanyForm(values: CompanyFormValues): CompanyFormResult {
	const name = values.name.trim();
	if (!name) {
		return { ok: false, message: '회사명을 입력해주세요.' };
	}

	const start = values.workStartTime;
	const end = values.workEndTime;
	if (!start || !end) {
		return { ok: false, message: '업무 시작과 종료 시간을 모두 입력해주세요.' };
	}
	if (start >= end) {
		return { ok: false, message: '업무 종료 시간은 시작 시간보다 늦어야 합니다.' };
	}

	return {
		ok: true,
		request: {
			name,
			businessNumber: optionalText(values.businessNumber),
			address: optionalText(values.address),
			phone: optionalText(values.phone),
			workStartTime: toApiTime(start),
			workEndTime: toApiTime(end)
		}
	};
}
